import { render, staticRenderFns } from "./goosShare.vue?vue&type=template&id=3f51f665&scoped=true"
import script from "./goosShare.vue?vue&type=script&lang=js"
export * from "./goosShare.vue?vue&type=script&lang=js"
import style0 from "./goosShare.vue?vue&type=style&index=0&id=3f51f665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f51f665",
  null
  
)

export default component.exports